import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RestaurantTrades = () => {
  
  return (
    <Box bg="gray.50" p={4}>
      {/* Main Content */}
    <Box bg="white" p={4} borderRadius="md" boxShadow="md" w={["100%", "100%", "80%"]} mx="auto">
        {/* Active Trades Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Active Trades
            </Text>
            {/* ... (active trades content) */}
        </Box>

        {/* Completed Trades Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Completed Trades
            </Text>
            {/* ... (completed trades content) */}
        </Box>

        {/* My Offers Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            My Offers
            </Text>
            {/* ... (my offers content) */}
        </Box>

        {/* Search for Offers Section */}
        <Box bg="blue.50" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <Text fontSize="xl" fontWeight="semibold">
            Search for Offers
            </Text>
            {/* ... (search for offers content) */}
        </Box>
    </Box>
          {/* Bottom Navigation for Mobile */}
          <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
    </Box>
  );
};

export default RestaurantTrades;
